import { apiProvider } from '@/services/api/utils/provider.js'

export class ApiCore {
	constructor(options) {
		if (options.index) {
			this.index = (option) => {
				return apiProvider.index(options.url, option)
			}
		}

		if (options.findOne) {
			this.findOne = (id) => {
				return apiProvider.findOne(options.url, id)
			}
		}

		if (options.findAll) {
			this.findAll = (params, option) => {
				return apiProvider.findAll(options.url, params, option)
			}
		}

		if (options.create) {
			this.create = (model) => {
				return apiProvider.create(options.url, model)
			}
		}

		if (options.update) {
			this.update = (model) => {
				return apiProvider.update(options.url, model)
			}
		}

		if (options.remove) {
			this.remove = (id) => {
				return apiProvider.remove(options.url, id)
			}
		}

		if (options.upload) {
			this.upload = (files) => {
				return apiProvider.upload(options.url, files)
			}
		}
	}
}
